import React from "react";
import { Edit } from "lucide-react";

interface FacilityRecord {
  facility: string;
  date: string;
  note: string;
}

const facilityRecords: FacilityRecord[] = [
  {
    facility: "Thailand Adventure",
    date: "03/02/2025",
    note: "Jayson's trip to Thailand while he was reporting his loss.",
  },
  {
    facility: "Adventure in the Mountains",
    date: "21/09/2025",
    note: "Jayson's extravagant trip to the Goa Barcelona match.",
  },
  {
    facility: "Flight Booking to Paradise",
    date: "14/06/2025",
    note: "Jayson's luxurious stay at the Atlantis Paradise Island resort.",
  },
  {
    facility: "Relaxing Retreat at the Resort",
    date: "07/07/2025",
    note: "Jayson's spontaneous road trip across the scenic Amalfi Coast.",
  },
  {
    facility: "Goa Getaway",
    date: "28/03/2025",
    note: "Jayson's adventurous safari in the heart of the Serengeti.",
  },
  {
    facility: "Weekend Escape to the Beach",
    date: "08/08/2025",
    note: "Jayson's serene cruise through the Norwegian fjords.",
  },
  {
    facility: "Cultural Tour of the City",
    date: "30/12/2025",
    note: "Jayson's trip back home.",
  },
];

export const FacilitiesTable: React.FC = () => {
  return (
    <div className="bg-slate-800 rounded-b-lg overflow-x-auto">
      <table className="w-full min-w-[640px]">
        <thead className="bg-slate-700">
          <tr>
            <th className="px-3 md:px-6 py-3 md:py-4 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">
              <div className="flex items-center gap-2">
                Facility
                <svg
                  className="w-3 h-3"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                </svg>
              </div>
            </th>
            <th className="px-3 md:px-6 py-3 md:py-4 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">
              <div className="flex items-center gap-2">
                Date
                <svg
                  className="w-3 h-3"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                </svg>
              </div>
            </th>
            <th className="px-3 md:px-6 py-3 md:py-4 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">
              <div className="flex items-center gap-2">
                Note
                <svg
                  className="w-3 h-3"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                </svg>
              </div>
            </th>
            <th className="px-3 md:px-6 py-3 md:py-4 text-center text-xs font-medium text-slate-300 uppercase tracking-wider">
              <div className="flex items-center justify-center gap-2">
                Action
                <svg
                  className="w-3 h-3"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                </svg>
              </div>
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-700">
          {facilityRecords.map((record, idx) => (
            <tr key={idx} className="hover:bg-slate-700 transition-colors">
              <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-xs md:text-sm text-slate-300">
                {record.facility}
              </td>
              <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-xs md:text-sm text-slate-300">
                {record.date}
              </td>
              <td className="px-3 md:px-6 py-3 md:py-4 text-xs md:text-sm text-slate-300 max-w-xs md:max-w-md">
                {record.note}
              </td>
              <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center">
                <button className="text-slate-400 hover:text-white transition-colors">
                  <Edit className="w-4 h-4" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {facilityRecords.length === 0 && (
        <div className="text-center py-12">
          <div className="text-slate-400">No records found</div>
        </div>
      )}
    </div>
  );
};
